<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { ChevronRight } from 'lucide-vue-next';

    interface Props {
        disabled?: boolean;
        loading?: boolean;
    }

    withDefaults(defineProps<Props>(), {
        disabled: false,
        loading: false,
    });
</script>

<template>
    <Button
        variant="continue"
        size="xs"
        :disabled="disabled || loading"
        :loading="loading"
    >
        <span><slot /></span>
        <ChevronRight />
    </Button>
</template>
